<div class="bg-brand-cream desk:bg-hero-edge desk:grid desk:grid-cols-[minmax(22rem,1fr)_2fr] desk:grid-rows-1 desk:h-svh desk:overflow-hidden">
    <div class="min-h-svh desk:min-h-0 desk:h-full w-full bg-brand-cream desk:bg-hero-edge flex flex-col relative">
        <div class="flex-1 basis-0"></div>
        <app-flame-logo class="mx-auto" />
        <app-socials class="-mt-12 relative z-10 pb-4"/>
        <p class="hidden desk:block font-body text-center text-black px-8 pt-4">HIGH HEAT is a rock band from Knoxville, Tennessee</p>
        <div class="flex flex-col items-center p-8">
            @let offset = nextShow() ? 1 : 0;
            <div class="w-full max-w-lg flex flex-col gap-4 text-black" [attr.inert]="landed() ? null : ''">
                @if (nextShow(); as show) {
                    <app-next-show class="land landed h-(--next-show-h)" [show]="show" (selected)="selectedShow.set($event)" />
                }
                <button class="land hh-btn hh-btn-secondary text-lg w-full" [class.landed]="landed()" [style.--i]="offset" (click)="openBooking()">Booking</button>
                <a href="https://forms.gle/wJRzyTFE6Tx9VViP7" target="_blank" rel="noopener noreferrer" class="land hh-btn hh-btn-secondary text-lg w-full" [class.landed]="landed()" [style.--i]="offset + 1">Email List</a>
                <a href="http://venmo.com/highheatrocks" target="_blank" rel="noopener noreferrer" class="land hh-btn hh-btn-secondary text-lg w-full" [class.landed]="landed()" [style.--i]="offset + 2">Tips</a>
            </div>
        </div>
        <!-- Without a next show this slot holds its space, so the page doesn't shift whether or not one arrives -->
        <div class="more-slot flex-1 basis-0 min-h-0" [class.landed]="landed()" [class.reserve-next-show]="!nextShow()" [style.--i]="offset + 2">
            <button type="button" (click)="scrollToMore()" aria-label="Scroll to more" class="more-hint desk:hidden text-black text-center cursor-pointer">
                <div class="font-hand text-2xl">more</div>
                <div class="-m-1">&#8595;</div>
            </button>
        </div>
    </div>
    <div id="more" class="desk:hidden scroll-mt-0 m-auto pt-8 pb-16 bg-brand-cream" style="max-width: 640px;">
        <div class="font-body text-center relative z-20 -mb-8 p-4"><p>HIGH HEAT is a rock band from Knoxville, Tennessee</p></div>
        <div class="overflow-hidden relative">
            <div class="bg-gradient-to-b from-brand-cream to-transparent absolute h-48 w-full top-0 left-0 z-10"></div>
            <img ngSrc="home-hero-tall.jpg" width="640" height="1033" alt="High Heat"/>
            <div class="bg-gradient-to-b from-transparent to-brand-cream absolute h-48 w-full bottom-0 left-0 z-10"></div>
        </div>
    </div>
    <div class="hidden desk:block relative h-full overflow-hidden">
        <img ngSrc="home-hero-wide.jpg" fill sizes="67vw" alt="High Heat" class="object-cover"/>
        <div class="bg-gradient-to-r from-hero-edge to-transparent absolute inset-y-0 left-0 w-48 z-10"></div>
    </div>
</div>

<app-booking [open]="bookingOpen()" (closed)="closeBooking()" />
<app-show-detail [show]="selectedShow()" (closed)="selectedShow.set(null)" />
